import { IBlogArticle } from '../api/types';

const BLOG_SLUG_PATTERN = /^[a-z\d]+(?:-[a-z\d]+)*$/;

export function isNumericBlogSlug(slug: string): boolean {
  return /^\d+$/.test(slug);
}

export function isBlogSlug(slug: string): boolean {
  return !isNumericBlogSlug(slug) && BLOG_SLUG_PATTERN.test(slug);
}

export function blogArticlePath(slug: string): string {
  return `/blog/${encodeURIComponent(slug)}`;
}

export function blogPlainText(html: string): string {
  if (!html) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');
  return (doc.body.textContent ?? '').replace(/\s+/g, ' ').trim();
}

export function visibleBlogArticles(articles: IBlogArticle[] | undefined): IBlogArticle[] {
  return (articles ?? []).filter(
    (article) => article.isVisible === true && isBlogSlug(article.slug),
  );
}
